export default __webpack_public_path__ + "static/media/greyGoogleMap.c954578e.png";